if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.sellifeTouchStart = null;
      this.sellifeControls = null;
      this.sellifeOnKeydown = (event) => {
        if (!this.hasAttribute('open') || !this.sellifeIsMobile()) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          if (this.sellifeItems().length < 2) return;
          event.preventDefault();
          this.sellifeStep(event.key === 'ArrowRight' ? 1 : -1);
        }
      };
    }

    sellifeIsMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    hide() {
      document.removeEventListener('keydown', this.sellifeOnKeydown);
      this.sellifeTouchStart = null;
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.sellifeSetupControls();
      this.sellifeUpdateControls();
      document.removeEventListener('keydown', this.sellifeOnKeydown);
      document.addEventListener('keydown', this.sellifeOnKeydown);
    }

    showActiveMedia() {
      const selectedId = this.openedBy && this.openedBy.getAttribute('data-media-id');
      const items = this.sellifeItems();
      if (!selectedId || !items.length) return;
      items.forEach((element) => element.classList.remove('active'));
      const activeMedia = items.find((element) => element.getAttribute('data-media-id') === selectedId) || items[0];
      activeMedia.classList.add('active');
      if (!this.sellifeIsMobile()) {
        activeMedia.scrollIntoView();
        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = ((activeMedia.width || 0) - container.clientWidth) / 2;
      }
      this.sellifePrepareMedia(activeMedia);
    }

    sellifeItems() {
      const content = this.querySelector('.product-media-modal__content');
      return content ? Array.from(content.children).filter((item) => item.hasAttribute('data-media-id')) : [];
    }

    sellifePrepareMedia(media) {
      const template = media.querySelector && media.querySelector('template');
      const youtube = template && template.content && template.content.querySelector('.js-youtube');
      if (media.nodeName === 'DEFERRED-MEDIA' && youtube && typeof media.loadContent === 'function') {
        media.loadContent();
      }
    }

    sellifeStep(direction) {
      if (!this.sellifeIsMobile()) return;
      const items = this.sellifeItems();
      if (items.length < 2) return;
      const current = items.findIndex((item) => item.classList.contains('active'));
      const nextIndex = (Math.max(current, 0) + direction + items.length) % items.length;
      items.forEach((item, index) => item.classList.toggle('active', index === nextIndex));
      this.sellifePrepareMedia(items[nextIndex]);
      this.sellifeUpdateControls();
    }

    sellifeSetupControls() {
      if (this.sellifeControls) return;
      const dialog = this.querySelector('.product-media-modal__dialog');
      const content = this.querySelector('.product-media-modal__content');
      if (!dialog || !content) return;

      const controls = document.createElement('div');
      controls.className = 'sellife-mobile-gallery-controls';
      controls.setAttribute('aria-label', 'Image navigation');
      controls.innerHTML = [
        '<button type="button" class="sellife-gallery-arrow sellife-gallery-prev" aria-label="Previous image">',
        '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg></button>',
        '<span class="sellife-gallery-counter" role="status" aria-live="polite" aria-atomic="true"></span>',
        '<button type="button" class="sellife-gallery-arrow sellife-gallery-next" aria-label="Next image">',
        '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg></button>'
      ].join('');
      dialog.appendChild(controls);
      this.sellifeControls = controls;
      controls.querySelector('.sellife-gallery-prev').addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.sellifeStep(-1);
      });
      controls.querySelector('.sellife-gallery-next').addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.sellifeStep(1);
      });

      content.addEventListener('touchstart', (event) => {
        this.sellifeTouchStart = null;
        if (!this.hasAttribute('open') || !this.sellifeIsMobile() || event.touches.length !== 1) return;
        if (event.target.closest('button, a, video, iframe, product-model, .deferred-media')) return;
        const touch = event.touches[0];
        this.sellifeTouchStart = { x: touch.clientX, y: touch.clientY };
      }, { passive: true });
      content.addEventListener('touchend', (event) => {
        const start = this.sellifeTouchStart;
        this.sellifeTouchStart = null;
        if (!start || !this.hasAttribute('open') || !this.sellifeIsMobile() || event.changedTouches.length !== 1) return;
        const touch = event.changedTouches[0];
        const dx = touch.clientX - start.x;
        const dy = touch.clientY - start.y;
        if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.25) {
          this.sellifeStep(dx < 0 ? 1 : -1);
        }
      }, { passive: true });
      content.addEventListener('touchcancel', () => { this.sellifeTouchStart = null; }, { passive: true });
    }

    sellifeUpdateControls() {
      if (!this.sellifeControls) return;
      const items = this.sellifeItems();
      this.sellifeControls.hidden = items.length < 2;
      const index = Math.max(0, items.findIndex((item) => item.classList.contains('active')));
      const counter = this.sellifeControls.querySelector('.sellife-gallery-counter');
      if (counter) counter.textContent = (index + 1) + ' / ' + items.length;
    }
  });
}